module.exports = __webpack_public_path__ + "static/media/card-front.24e7cd59.svg";